<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import numberMixin from '../../../../mixins/numberMixin';
import ConfirmDialog from '../../../../components/TwConfirmDialog';
import statusEnums from '../../../../variables/ski/school/status-type-enums';
import commentTypeEnums from '../../../../variables/ski/school/comment-type.enums';
import lessonTypeEnums from '../../../../variables/ski/school/lesson-type-enums';

export default {
  name: 'SkiSchoolOverview',
  data() {
    return {
      commentTypeEnums,
      lessonTypeEnums,
      isPriceChanged: false,
      isProductChanged: false,
      editProductDialog: false,
      selectedSchool: undefined,
      isSearchingForAnotherProduct: false,
      selectedArea: undefined,
      supplierRefs: {},
      editProductPrices: {
        price: undefined,
        priceNet: undefined,
      },
      selectedParticipantId: undefined,
      comment: undefined,
      commentType: undefined,
      commentModal: false,
      datePickerModal: false,
      timePickerModal: false,
      currentSkiSchool: undefined,
    };
  },
  components: {
    ConfirmDialog,
  },
  mixins: [numberMixin],
  filters: {
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
  },
  created() {
    this.schools.items.forEach((school) => {
      this.$set(this.supplierRefs, school.id, school.supplierRef);
    });
  },
  mounted() {
    if (this.booking) {
      this.booking.stays.forEach((stay) => {
        this.loadSchoolMeetingPoint(stay.areaId);
      });
    }
  },
  computed: {
    ...mapGetters({
      schoolsMapped: 'skischool/getSkiSchools',
      totalPrice: 'skischool/getSkiSchoolTotalPrice',
      availableSchoolProducts: 'skischool/getAvailableSkiSchoolProducts',
      bookingParticipantsWhereSchoolsExist: 'skischool/getBookingParticipantsWhereSchoolsExist',
      participants: 'booking/getParticipantsWithFullName',
      defaultStartDate: 'booking/getMinimumArrivalDateFromBookingStays',
      availableDates: 'booking/getAvailableDates',
      availableSchoolProductsPersonCategoryHeaders: 'skischool/getAvailableSkiSchoolProductsPersonCategoryHeaders',
      availableSkiSchoolProductUsedForChangeProduct: 'skischool/getAvailableSkiSchoolProductUsedForChangeProduct',
      twentyBookingCustomerUrl: 'booking/getTwentyBookingCustomerUrl',
      defaultAreaId: 'booking/getDefaultAreaId',
      areasWithAllOption: 'skischool/getBookingStayAreasWithAllOption',
      availableNumberOfDays: 'skischool/getAvailableNumberOfDays',
      availableLessonTypes: 'skischool/getAvailableLessonTypesUsedForChangeProduct',
      availableWeekDays: 'skischool/getAvailableWeekDaysUsedForChangeProduct',
      availableNumberOfDaysUsedForChangeProduct: 'skischool/getAvailableNumberOfDaysUsedForChangeProduct',
      availablePersonCategoriesUsedForChangeProduct: 'skischool/getAvailablePersonCategoriesUsedForChangeProduct',
      availableLessonDurations: 'skischool/getAvailableLessonDurationsUsedForChangeProduct',
      availableSkiTypes: 'skischool/getAvailableSkiTypesUsedForChangeProduct',
      availableNumberOfPersons: 'skischool/getAvailableNumberOfPersonsUsedForChangeProduct',
      availableLevelTypes: 'skischool/getAvailableLevelTypesUsedForChangeProduct',
    }),
    ...mapState({
      schools: state => state.skischool.schools,
      booking: state => state.booking.booking,
      bookingParticipants: state => state.booking.participants,
      user: state => state.app.auth.user,
      availableSchoolProducts: state => state.skischool.availableSchoolProducts,
      selectedSearchBookingParticipantId:
        state => state.skischool.search.selectedBookingParticipantId,
      selectedAreaId: state => state.skischool.search.selectedAreaId,
      areas: state => state.booking.areas.items,
      meetingPoints: state => state.skischool.meetingPoints,
      selectedBookingParticipantId:
        state => state.skischool.changeProduct.selectedBookingParticipantId,
      selectedPersonCategoryId: state => state.skischool.changeProduct.selectedPersonCategoryId,
      selectedNumberOfDays: state => state.skischool.changeProduct.selectedNumberOfDays,
      selectedAreaIdForChangeProduct: state => state.skischool.changeProduct.selectedAreaId,
      selectedLessonTypeId: state => state.skischool.changeProduct.selectedLessonTypeId,
      selectedWeekDayNumber: state => state.skischool.changeProduct.selectedWeekDayNumber,
      selectedLessonDuration: state => state.skischool.changeProduct.selectedLessonDuration,
      selectedLevelId: state => state.skischool.changeProduct.selectedLevelId,
      selectedNumberOfPersons: state => state.skischool.changeProduct.selectedNumberOfPersons,
      selectedSkiTypeId: state => state.skischool.changeProduct.selectedSkiTypeId,
    }),
    canChangeProduct() {
      return (this.isProductChanged || this.isPriceChanged)
        && (
          !this.isSearchingForAnotherProduct
          || (
            this.isSearchingForAnotherProduct
            && this.availableSkiSchoolProductUsedForChangeProduct
            && this.selectedBookingParticipantId
            && this.selectedAreaIdForChangeProduct
            && this.selectedPersonCategoryId
            && this.selectedNumberOfDays
            && this.selectedLessonTypeId
            && this.selectedWeekDayNumber !== undefined
            && this.selectedLessonDuration
            && this.selectedLevelId
            && this.selectedNumberOfPersons
            && this.selectedSkiTypeId
          )
        )
        && this.selectedSchool.price !== undefined
        && this.selectedSchool.priceNet !== undefined;
    },
    loading() {
      return this.schools.itemsLoading
        || this.schools.saveLoading
        || this.booking.itemLoading
        || this.bookingParticipants.itemsLoading;
    },
    errorOccurred() {
      return this.schools.itemsError
        || this.booking.itemError
        || this.bookingParticipants.itemsError;
    },
  },
  methods: {
    ...mapActions({
      saveSchool: 'skischool/schoolUpdate',
      saveSchoolPrice: 'skischool/schoolPriceUpdate',
      saveCancellationFeeNet: 'skischool/schoolCancellationFeeNetUpdate',
      saveSchoolSupplierRef: 'skischool/schoolSupplierRefUpdate',
      saveSchoolParticipant: 'skischool/schoolParticipantUpdate',
      deleteSchool: 'skischool/schoolDelete',
      stopSchool: 'skischool/schoolStop',
      cancelSchool: 'skischool/schoolCancel',
      reOpenSchool: 'skischool/reopenSkiSchool',
      loadAvailableSchoolPrices: 'skischool/availableSchoolPricesLoad',
      schoolParticipantCreate: 'skischool/schoolParticipantCreate',
      schoolParticipantDelete: 'skischool/schoolParticipantDelete',
      loadSchoolMeetingPoint: 'skischool/loadSkiSchoolMeetingPointsByTwentyAreaId',
      sendSkiSchoolRequestEmail: 'skischool/sendSkiSchoolRequestEmail',
      schoolCustomerCommentUpdate: 'skischool/schoolCustomerCommentUpdate',
      schoolSupplierCommentUpdate: 'skischool/schoolSupplierCommentUpdate',
      schoolMeetingPointUpdate: 'skischool/schoolMeetingPointUpdate',
      schoolStartDateTimeUpdate: 'skischool/schoolStartDateTimeUpdate',
      setBookingParticipant: 'skischool/setBookingParticipant',
      setNumberOfDays: 'skischool/setNumberOfDays',
      setArea: 'skischool/setArea',
      setChangeProductBookingParticipant: 'skischool/setChangeProductBookingParticipant',
      setChangeProductNumberOfDays: 'skischool/setChangeProductNumberOfDays',
      setChangeProductPersonCategory: 'skischool/setChangeProductPersonCategory',
      setChangeProductArea: 'skischool/setChangeProductArea',
      setChangeProductLessonType: 'skischool/setChangeProductLessonType',
      setChangeProductWeekDayNumber: 'skischool/setChangeProductWeekDayNumber',
      setChangeProductLessonDuration: 'skischool/setChangeProductLessonDuration',
      setChangeProductLevelType: 'skischool/setChangeProductLevelType',
      setChangeProductNumberOfPersons: 'skischool/setChangeProductNumberOfPersons',
      setChangeProductSkiType: 'skischool/setChangeProductSkiType',
    }),
    updateSupplierRef(skiSchool) {
      const supplierRef = this.supplierRefs[skiSchool.id] ? this.supplierRefs[skiSchool.id] : null;
      if (supplierRef && supplierRef.length && supplierRef !== skiSchool.supplierRef) {
        this.saveSchoolSupplierRef({ supplierRef, skiSchool });
      } else {
        this.$set(this.supplierRefs, skiSchool.id, skiSchool.supplierRef);
      }
    },
    selectCurrentSchool(school) {
      this.selectedSchool = Object.assign({}, school);
    },
    deselectCurrentSchool() {
      this.selectedSchool = undefined;
    },
    openEditProductDialog(school) {
      this.selectCurrentSchool(school);
      this.isPriceChanged = false;
      this.isProductChanged = false;
      this.isSearchingForAnotherProduct = false;
      this.setChangeProductPersonCategory(school.productsSkiSchoolPersonCategoryId);
      this.setChangeProductNumberOfDays(school.numberOfDays);
      this.setChangeProductPersonCategory(school.productsSkiSchoolSeasonPersonCategoryId);
      this.setChangeProductArea(school.area.id);
      this.setChangeProductLessonType(school.productsSkiSchoolLessonTypeId);
      this.setChangeProductWeekDayNumber(school.weekDay);
      this.setChangeProductLessonDuration(school.minutes);
      this.setChangeProductLevelType(school.productsSkiSchoolSeasonLevelId);
      this.setChangeProductNumberOfPersons(school.maxNumberOfPersons);
      this.setChangeProductSkiType(school.productsSkiSchoolSkiTypeId);
      this.editProductDialog = true;
    },
    async saveProductDialog() {
      let closeDiaLog = false;
      this.setGrossNetPricesOnSelectedSchool();
      if (this.isSearchingForAnotherProductAndProductChanged()) {
        const newProduct = this.availableSkiSchoolProductUsedForChangeProduct;
        const ageTranslation = this.$t('ski.school.years-from-to', {
          from: newProduct.personCategory.ageFrom,
          to: newProduct.personCategory.ageTo,
        });
        const personCategoryAges = `(${ageTranslation})`;
        let startDateTime = this.selectedSchool.startDateTime;
        const targetWeekDay = newProduct.weekDay;
        if (lessonTypeEnums.GROUP === newProduct.lessonType.id) {
          const bookingStay = this.getBookingStayByAreaId(this.selectedAreaIdForChangeProduct);
          const arrivalDate = new Date(bookingStay.arrivalDate);
          const departureDate = new Date(bookingStay.departureDate);
          for (let d = arrivalDate; d <= departureDate; d.setDate(d.getDate() + 1)) {
            const currentDate = new Date(d);
            if (targetWeekDay === currentDate.getDay()) {
              const startDate = currentDate.toISOString().substr(0, 10);
              startDateTime = `${startDate} 00:00:00`;
              break;
            }
          }
        }
        const changedProduct = {
          id: this.selectedSchool.id,
          participantId: this.selectedSchool.participants[0].id,
          priceUserAgentId: this.isPriceChanged ? this.user.id : null,
          cancelledUserAgentId: null,
          productsSkiSchoolSeasonId: newProduct.season.id,
          productsSkiSchoolSeasonPersonCategoryId: newProduct.personCategory.id,
          productsSkiSchoolSeasonLevelId: newProduct.level.id,
          productsSkiSchoolSkiTypeId: newProduct.skiType.id,
          productsSkiSchoolLessonTypeId: newProduct.lessonType.id,
          productsSkiSchoolMeetingPointId: this.selectedSchool.productsSkiSchoolMeetingPointId,
          status: statusEnums.INITIATED,
          salesType: this.selectedSchool.salesType,
          supplierRef: null,
          supplierComment: this.selectedSchool.supplierComment,
          customerComment: this.selectedSchool.customerComment,
          weekDay: targetWeekDay,
          startDateTime,
          maxNumberOfPersons: newProduct.numberOfPersons,
          numberOfDays: newProduct.days,
          minutes: newProduct.durationMinutes,
          price: this.$options.filters.roundNumber(this.editProductPrices.price),
          priceNet: this.$options.filters.roundNumber(this.editProductPrices.priceNet),
          currencyNet: newProduct.season.supplier.currency,
          supplierName: newProduct.season.supplier.name,
          seasonName: newProduct.season.name,
          personCategoryName: newProduct.personCategory.name + personCategoryAges,
          levelName: newProduct.level.name,
          skiTypeName: newProduct.skiType.name,
          lessonTypeName: newProduct.lessonType.name,
          meetingPointName: this.selectedSchool.meetingPointName,
          seasonNameSupplier: newProduct.season.name,
          personCategoryNameSupplier: newProduct.personCategory.externalName
            + personCategoryAges,
          levelNameSupplier: newProduct.level.externalName,
          skiTypeNameSupplier: newProduct.skiType.identifier,
          lessonTypeNameSupplier: newProduct.lessonType.identifier,
          meetingPointNameSupplier: this.selectedSchool.meetingPointNameSupplier,
        };
        closeDiaLog = await this.saveSchool({
          changedProduct,
          bookingId: this.booking.id,
        });
      } else if (this.isPriceChanged) {
        const changedProductPrice = {
          id: this.selectedSchool.id,
          priceUserAgentId: this.user.id,
          price: this.editProductPrices.price,
          priceNet: this.editProductPrices.priceNet,
          currencyNet: this.selectedSchool.currencyNet,
        };
        closeDiaLog = await this.saveSchoolPrice({
          changedProductPrice,
          bookingId: this.booking.id,
        });
      }
      closeDiaLog = await this.saveCancellationFeeNet({
        skiSchoolId: this.selectedSchool.id,
        cancellationFeeNet: this.selectedSchool.cancellationFeeNet.length
          ? this.$options.filters.roundNumber(this.selectedSchool.cancellationFeeNet)
          : 0,
        bookingId: this.booking.id,
      });
      if (closeDiaLog && !this.schools.saveError) {
        this.editProductDialog = false;
        this.deselectCurrentSchool();
      }
    },
    closeProductDialog() {
      this.editProductDialog = false;
      this.selectedArea = undefined;
      this.isSearchingForAnotherProduct = false;
      this.deselectCurrentSchool();
    },
    isSearchingForAnotherProductAndProductChanged() {
      return this.isSearchingForAnotherProduct
        && this.isProductChanged
        && this.availableSkiSchoolProductUsedForChangeProduct;
    },
    setGrossNetPricesOnSelectedSchool() {
      let price;
      let priceNet;
      if (this.isSearchingForAnotherProductAndProductChanged()) {
        const newProduct = this.availableSkiSchoolProductUsedForChangeProduct;
        price = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          newProduct.priceGross,
        ));
        priceNet = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          newProduct.priceNet,
        ));
        if (this.isPriceChanged) {
          price = this.$options.filters.roundNumber(
            this.$options.filters.numberToDots(this.selectedSchool.price),
          );
          priceNet = this.$options.filters.roundNumber(
            this.$options.filters.numberToDots(this.selectedSchool.priceNet),
          );
        }
      } else if (this.isPriceChanged) {
        price = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          this.selectedSchool.price,
        ));
        priceNet = this.$options.filters.roundNumber(this.$options.filters.numberToDots(
          this.selectedSchool.priceNet,
        ));
      }
      this.editProductPrices.price = price;
      this.editProductPrices.priceNet = priceNet;
    },
    deleteProductDialog(skiSchoolId) {
      this.deleteSchool({ skiSchoolId, salesAgentUserId: this.user.id });
    },
    stopProductDialog(skiSchoolId) {
      this.stopSchool({ skiSchoolId, salesAgentUserId: this.user.id, bookingId: this.booking.id });
    },
    cancelProductDialog(skiSchoolId) {
      this.cancelSchool({
        skiSchoolId,
        salesAgentUserId: this.user.id,
        bookingId: this.booking.id,
      });
    },
    reOpenProductDialog(skiSchoolId) {
      this.reOpenSchool({
        skiSchoolId,
        bookingId: this.booking.id,
        status: statusEnums.INITIATED,
      });
    },
    searchAvailableProducts() {
      this.isSearchingForAnotherProduct = true;
      const participant = this.participants.find(
        item => item.id === this.selectedBookingParticipantId,
      );
      const areaId = this.selectedAreaIdForChangeProduct;
      const bookingStay = this.getBookingStayByAreaId(areaId);
      this.loadAvailableSchoolPrices({
        areaId,
        participantAge: participant.age,
        arrivalDate: bookingStay.arrivalDate,
        departureDate: bookingStay.departureDate,
        targetCurrency: this.booking.currency,
      });
    },
    getBookingStayByAreaId(areaId) {
      return this.booking.stays.find(
        stay => stay.areaId === areaId,
      );
    },
    takeGrossNetPrice(availableSkiSchoolProduct) {
      this.isProductChanged = true;
      this.selectedSchool.price
        = this.$options.filters.roundNumber(availableSkiSchoolProduct.priceGross);
      this.selectedSchool.priceNet
        = this.$options.filters.roundNumber(availableSkiSchoolProduct.priceNet);
      this.selectedSchool.currencyNet = availableSkiSchoolProduct.season.supplier.currency;
    },
    updateSchoolMeetingPoint(meetingPoint, skiSchoolId) {
      const meetingPointRequest = {
        ...meetingPoint,
        nameSupplier: meetingPoint.name,
      };
      this.schoolMeetingPointUpdate({
        bookingId: this.booking.id,
        skiSchoolId,
        meetingPointRequest,
      });
    },
    addParticipant(params) {
      this.schoolParticipantCreate({
        bookingId: this.booking.id,
        skiSchoolId: params.school.id,
        bookingParticipantId: this.selectedParticipantId,
      });
      this.selectedParticipantId = undefined;
    },
    deleteParticipant(params) {
      this.schoolParticipantDelete({
        bookingId: this.booking.id,
        skiSchoolId: params.school.id,
        bookingParticipantId: params.participant.id,
      });
    },
    async saveComment() {
      const commentRequest = {
        bookingId: this.booking.id,
        skiSchoolId: this.currentSkiSchool.id,
        comment: this.comment,
      };
      let closeDialog = false;
      if (this.commentType === commentTypeEnums.CUSTOMER) {
        closeDialog = await this.schoolCustomerCommentUpdate(commentRequest);
      } else {
        closeDialog = await this.schoolSupplierCommentUpdate(commentRequest);
      }
      if (closeDialog && !this.schools.saveError) {
        this.closeCommentModal();
      }
    },
    async saveStartDate() {
      let startTime = '00:00:00';
      if (this.currentSkiSchool.startTime) {
        startTime = `${this.currentSkiSchool.startTime}:00`;
      }
      const startDateTime = `${this.currentSkiSchool.startDate} ${startTime}`;
      const closeDialog = await this.schoolStartDateTimeUpdate({
        bookingId: this.booking.id,
        skiSchoolId: this.currentSkiSchool.id,
        startDateTime,
      });
      if (closeDialog && !this.schools.saveError) {
        this.closeDatePickerModal();
      }
    },
    async saveStartTime() {
      let startDate = '0000-00-00';
      if (this.currentSkiSchool.startDate) {
        startDate = this.currentSkiSchool.startDate;
      }
      const startDateTime = `${startDate} ${this.currentSkiSchool.startTime}:00`;
      const closeDialog = await this.schoolStartDateTimeUpdate({
        bookingId: this.booking.id,
        skiSchoolId: this.currentSkiSchool.id,
        startDateTime,
      });
      if (closeDialog && !this.schools.saveError) {
        this.closeTimePickerModal();
      }
    },
    sendRequestEmail() {
      this.sendSkiSchoolRequestEmail(this.booking.id);
    },
    previewRequestEmail() {
      return `${process.env.TWENTY_API_URL}booking/ski/school/booking/${this.booking.id}/preview-supplier-request`;
    },
    onAreaChange(areaId) {
      this.selectedArea = areaId;
      this.searchAvailableProducts();
    },
    onPersonCategoryChange(personCategoryId) {
      this.setChangeProductPersonCategory(personCategoryId);
    },
    onPriceOverrideChange() {
      this.isPriceChanged = true;
    },
    onFilterAreaChange(areaId) {
      this.setArea(areaId);
    },
    onBookingParticipantChange(participantId) {
      this.setBookingParticipant(participantId);
    },
    openConfirmDialog(type) {
      const vueComponent = this.$refs[type];
      if (vueComponent instanceof Array) {
        vueComponent[0].open();
      } else {
        vueComponent.open();
      }
    },
    openCommentModal(commentType, school) {
      this.currentSkiSchool = school;
      this.commentModal = true;
      this.commentType = commentType;
      this.comment = commentType === commentTypeEnums.CUSTOMER
        ? school.customerComment
        : school.supplierComment;
    },
    closeCommentModal() {
      this.commentModal = false;
      this.currentSkiSchool = undefined;
      this.comment = undefined;
    },
    openDatePickerModal(school) {
      this.currentSkiSchool = school;
      this.datePickerModal = true;
    },
    closeDatePickerModal() {
      this.currentSkiSchool = undefined;
      this.datePickerModal = false;
    },
    openTimePickerModal(school) {
      this.currentSkiSchool = school;
      this.timePickerModal = true;
    },
    closeTimePickerModal() {
      this.currentSkiSchool = undefined;
      this.timePickerModal = false;
    },
  },
};
</script>

<template>
  <v-container v-if="booking && booking.id" class="pa-0 pt-3" grid-list-xl>
    <div class="text-center pa-1">
      <v-progress-linear v-if="loading" indeterminate/>
    </div>
    <v-card
      class="pa-3 mb-3 mx-auto"
      outlined
    >
      <v-layout class="pt-3 pl-3 pr-3">
        <v-flex class="ma-0 pa-0" sm5 xs12>
          <v-select
            @change="onBookingParticipantChange($event)"
            :value="selectedSearchBookingParticipantId"
            :items="bookingParticipantsWhereSchoolsExist"
            :loading="bookingParticipants.itemsLoading"
            :disabled="
              bookingParticipants.itemsLoading
              || !bookingParticipantsWhereSchoolsExist.length
            "
            :label="$t('ski.school.selects.booking-participant')"
            item-text="fullName"
            item-value="id"
          />
        </v-flex>
        <v-flex v-if="areas.length > 1" class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onFilterAreaChange($event)"
            :value="selectedAreaId"
            :items="areasWithAllOption"
            :disabled="!bookingParticipantsWhereSchoolsExist.length"
            :label="$t('ski.school.selects.area')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
      </v-layout>
    </v-card>
    <v-alert
      v-if="
        !schoolsMapped.length
        && !this.booking.itemLoading
        && !this.bookingParticipants.itemsLoading
      "
      color="warning"
      icon="info"
      outline
    >
      {{ $t('ski.school.no-ski-school-exist-on-this-booking') }}
    </v-alert>
    <div
      v-for="school in schoolsMapped"
      :key="school.id"
      class="py-2"
    >
      <v-layout class="pb-0 mb-0" row>
        <v-flex class="pb-0 mb-0" sm4 xs12>
          <h2 class="font-weight-bold">
            <template v-if="school.maxNumberOfPersons > 1">
              {{ school.lessonTypeName }},
              {{ school.skiTypeName }},
              max {{ school.maxNumberOfPersons }} persons
            </template>
            <template v-else-if="school.participants.length">
              {{ school.participants[0].firstName }} {{ school.participants[0].lastName }}
            </template>
            <template v-else>
              No Participant
            </template>
            <template v-if="areas.length > 1">
              ({{ school.area.name }})
            </template>
          </h2>
          <div v-if="school.ageMismatch">
            <v-icon class="red--text" title="Missing height">warning</v-icon>
            <span class="red--text">{{ $t('ski.school.age-mismatch') }}</span>
          </div>
        </v-flex>
        <v-flex class="pb-0 mb-0 text-md-center" sm2 xs3>
          <v-chip :color="school.statusColor" text-color="white" disabled>
            {{ school.statusName }}
            <v-icon right>{{ school.statusIcon }}</v-icon>
          </v-chip>
        </v-flex>
        <v-flex class="pb-0 mb-0 no-wrap" sm2 xs12>
          <h2>
            {{ school.price }} {{ booking.currency }}
            <span class="blue-grey--text body-2 caption">
              <template v-if="school.cancellationFeeNet !== null">
                  / {{ school.cancellationFeeNet }} {{ school.currencyNet }}
                </template>
                <template v-else>
                  / {{ school.priceNet }} {{ school.currencyNet }}
                </template>
            </span>
          </h2>
          <span
            v-if="school.priceUserAgentId"
            class="red--text"
            :title="school.priceUserAgentId"
          >
            {{ $t('ski.school.price-modified') }}
          </span>
        </v-flex>
        <v-flex class="pb-0 mb-0 ml-auto text-md-right no-wrap" sm3 xs0>
          <v-btn
            @click.stop="openEditProductDialog(school)"
            :disabled="loading"
            color="warning"
            dark
            small
          >
            {{ $t('inputs.actions.edit') }}
          </v-btn>
          <template v-if="['stopped', 'cancelled'].includes(school.status)">
            <v-btn
              @click="openConfirmDialog('confirm-reopen-dialog-' + school.id)"
              :disabled="loading"
              color="error"
              small
            >
              {{ $t('inputs.actions.reopen') }}
            </v-btn>
            <confirm-dialog
              @confirm="reOpenProductDialog(school.id)"
              :title="$t('ski.school.confirm-title')"
              :description="$t('ski.school.reopenAreYouSure')"
              :ref="'confirm-reopen-dialog-' + school.id"
            >
            </confirm-dialog>
          </template>
          <template v-else>
            <v-btn
              v-if="school.supplierRef"
              @click="openConfirmDialog('confirm-stop-dialog-' + school.id)"
              :disabled="loading"
              color="error"
              small
            >
              {{ $t('inputs.actions.stop') }}
            </v-btn>
            <v-btn
              v-else
              @click="openConfirmDialog('confirm-delete-dialog-' + school.id)"
              :disabled="loading"
              color="error"
              small
            >
              {{ $t('inputs.actions.delete') }}
            </v-btn>
            <confirm-dialog
              @confirm="deleteProductDialog(school.id)"
              :title="$t('ski.school.confirm-title')"
              :description="$t('ski.school.deleteAreYouSure')"
              :ref="'confirm-delete-dialog-' + school.id"
            >
            </confirm-dialog>
            <confirm-dialog
              @confirm="stopProductDialog(school.id)"
              :title="$t('ski.school.confirm-title')"
              :description="$t('ski.school.stopAreYouSure')"
              :ref="'confirm-stop-dialog-' + school.id"
            >
            </confirm-dialog>
            <confirm-dialog
              @confirm="cancelProductDialog(school.id)"
              :title="$t('ski.school.confirm-title')"
              :description="$t('ski.school.cancelAreYouSure')"
              :ref="'confirm-cancel-dialog-' + school.id"
            >
            </confirm-dialog>
          </template>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex class="font-weight-bold py-0 mb-0" sm3 xs12>
          <template v-if="school.maxNumberOfPersons === 1">
            {{ school.lessonTypeName }}
            ({{ school.skiTypeName }} {{ school.maxNumberOfPersons }})
          </template>
        </v-flex>
        <v-flex v-if="!school.isLessonTypePrivate" class="font-weight-bold py-0 mb-0" sm3 xs12>
          {{ school.personCategoryName }}
        </v-flex>
      </v-layout>
      <v-layout class="no-wrap" row>
        <v-flex class="py-0 mb-0" sm3 xs12>
          {{ $t('ski.school.level') }}: <span class="font-weight-bold">{{ school.levelName }}</span>
        </v-flex>
        <v-flex class="py-0 mb-0" sm3 xs12>
          {{ $t('ski.school.per-session') }}:
          <span class="font-weight-bold">{{ school.minutes }} minutes</span>
        </v-flex>
        <v-flex class="py-0 mb-0" sm3 xs12>
          <template v-if="!school.isLessonTypePrivate">
            {{ $t('ski.school.number-of-days') }}:
            <span class="font-weight-bold">
              {{ school.numberOfDays }} {{ $t('ski.school.days') }}
            </span>
          </template>
        </v-flex>
        <v-flex class="py-0 my-0 text-md-right" sm3 xs12>
          <v-text-field
            @blur="updateSupplierRef(school)"
            v-model="supplierRefs[school.id]"
            :disabled="schools.saveLoading"
            :label="$t('ski.school.supplier-ref')"
            :success="!!school.supplierRef"
            :error="!school.supplierRef"
            :append-outer-icon="school.supplierRef ? 'check_circle' : 'warning'"
            type="text"
            class="py-0 my-0"
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-layout class="no-wrap" row>
        <v-flex class="py-0 mb-0" sm3 xs12>
          <template v-if="school.isLessonTypePrivate">
            <v-text-field
              @click="openDatePickerModal(school)"
              v-model="school.startDate"
              :label="$t('ski.school.start-date')"
              :show-current="true"
              prepend-icon="event"
              class="py-0 my-0"
              readonly
            >
              <template v-if="!schools.itemsLoading" v-slot:append-outer>
                <v-icon
                  v-if="school.startDate && school.startDate !== '0000-00-00'"
                  color="green">
                  check_circle
                </v-icon>
                <v-icon v-else color="red">warning</v-icon>
              </template>
            </v-text-field>
          </template>
          <template v-else>
            {{ $t('ski.school.week-day') }}:
            <span class="font-weight-bold">
              {{ school.weekDayName }} ({{ school.startDate }})
            </span>
          </template>
        </v-flex>
        <v-flex class="py-0 mb-0" xs12 sm2>
          <v-text-field
            @click="openTimePickerModal(school)"
            v-model="school.startTime"
            :label="$t('ski.school.start-time')"
            prepend-icon="access_time"
            class="py-0 my-0"
            readonly
          >
            <template v-if="!schools.itemsLoading" v-slot:append-outer>
              <v-icon
                v-if="school.startTime && school.startTime !== '00:00'"
                color="green">
                check_circle
              </v-icon>
              <v-icon v-else color="red">warning</v-icon>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex class="pb-0 mb-0 ml-auto text-md-right" sm4 xs0>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click.stop="openCommentModal(commentTypeEnums.CUSTOMER, school)"
                :disabled="loading"
                :color="school.customerComment ? 'success' : 'warning'"
                small
              >
                {{ $t('ski.school.buttons.customer-comment') }}
              </v-btn>
            </template>
            <span>
              {{ school.customerComment ? school.customerComment : 'none' }}
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click.stop="openCommentModal(commentTypeEnums.SUPPLIER, school)"
                :disabled="loading"
                :color="school.supplierComment ? 'success' : 'warning'"
                small
              >
                {{ $t('ski.school.buttons.supplier-comment') }}
              </v-btn>
            </template>
            <span>
              {{ school.supplierComment ? school.supplierComment : 'none' }}
            </span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex class="font-weight-bold py-0 mb-0" sm3 xs12>
          <v-select
            @change="updateSchoolMeetingPoint($event, school.id)"
            :value="school.productsSkiSchoolMeetingPointId"
            :items="school.meetingPoints"
            :disabled="meetingPoints.itemsLoading || !school.meetingPoints.length"
            :label="$t('ski.school.selects.meeting-point')"
            :title="school.meetingPointName"
            item-text="name"
            item-value="id"
            class="pt-0 mt-0"
            return-object
          >
            <template v-if="!meetingPoints.itemsLoading" v-slot:append-outer>
              <v-icon
                v-if="school.productsSkiSchoolMeetingPointId"
                :title="school.meetingPointName"
                color="green">
                check_circle
              </v-icon>
              <v-icon v-else color="red">warning</v-icon>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <template v-if="school.cancellationFeeNet === null">
        <v-layout class="pb-0">
          <v-flex class="pb-0 mb-0" sm2 xs12>
            <h3>{{ $t('ski.school.participants') }}</h3>
          </v-flex>
          <template v-if="school.maxNumberOfPersons !== school.participants.length">
            <v-flex class="pb-0 mb-0" sm3 xs12>
              <v-select
                v-model="selectedParticipantId"
                :items="school.availableParticipants"
                :disabled="
                  meetingPoints.itemsLoading
                  || !school.availableParticipants.length
                  || school.participants.length === school.maxNumberOfPersons
                "
                :label="$t('ski.school.selects.booking-participant')"
                :title="school.meetingPointName"
                item-text="fullName"
                item-value="id"
                class="pt-0 mt-0"
              />
            </v-flex>
            <v-flex class="pb-0 mb-0" sm7 xs12>
              <v-btn
                @click="addParticipant({ school })"
                :disabled="
                  school.participants.length === school.maxNumberOfPersons
                  || !selectedParticipantId
                "
                class="mb-2"
                color="warning"
                small
              >
                {{ $t('ski.school.add-participant') }}
              </v-btn>
            </v-flex>
          </template>
        </v-layout>
        <v-layout>
          <v-flex class="pb-2 mb-0" sm12 xs12>
            <div
              v-for="participant in school.participants"
              :key="participant.id"
              class="py-0 my-0"
            >
              {{ participant.firstName }} {{ participant.lastName }},
              <span
                v-if="participant.validBirthday"
                class="font-weight-bold"
              >
                {{ participant.birthday | formatDate }}
                ({{ participant.age }}
                {{ $t('ski.school.years-old') }})
                <v-icon class="green--text">
                  check_circle
                </v-icon>
              </span>
              <span v-else class="font-weight-bold">
              {{ participant.age }} {{ $t('ski.school.years-old') }}
              <v-icon class="red--text">warning</v-icon>
              <a :href="twentyBookingCustomerUrl" target="_blank" class="red--text">
                {{ $t('ski.school.birthday-not-verified') }}
              </a>
            </span>
              <v-btn
                @click="openConfirmDialog(
                  'confirm-delete-participant-dialog-' + school.id + '-' + participant.id
                )"
                :disabled="loading || school.participants.length === 1"
                color="error"
                small
              >
                {{ $t('inputs.actions.delete') }}
              </v-btn>
              <confirm-dialog
                @confirm="deleteParticipant({ school, participant })"
                :title="$t('ski.school.confirm-title')"
                :description="$t('ski.school.deleteAreYouSure')"
                :ref="'confirm-delete-participant-dialog-' + school.id + '-' + participant.id"
              >
              </confirm-dialog>
            </div>
          </v-flex>
        </v-layout>
      </template>
      <v-divider></v-divider>
    </div>
    <v-layout
      v-if="
        schoolsMapped.length
        && !this.booking.itemLoading
        && !this.bookingParticipants.itemsLoading
      "
      class="no-wrap pt-3"
      row
    >
      <v-flex class="ma-0 pa-0 text-md-right" sm8 xs12>
        <a
          :href="previewRequestEmail()"
          target="_blank"
          class="v-btn theme--dark success"
        >
          Preview request
        </a>
        <v-btn
          @click="sendRequestEmail"
          :disabled="loading"
          color="success"
          dark
        >
          {{ $t('ski.school.send-request-email') }}
        </v-btn>
      </v-flex>
      <v-flex class="ma-0 pa-0 text-md-center" sm4 xs4>
        <h1 class="text-uppercase">
          {{ $t('ski.school.total') }} {{ totalPrice.totalGross }} {{ booking.currency }}
          <span class="blue-grey--text caption">
            / {{ totalPrice.totalNet }}
          </span>
        </h1>
      </v-flex>
    </v-layout>
    <v-dialog v-model="commentModal" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('ski.school.add-comment-here', { commentType }) }}</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-alert
            v-if="schools.saveError"
            :value="schools.saveError"
            color="error"
            icon="warning"
            outline
          >
            <span v-html="schools.saveError"></span>
          </v-alert>
          <v-flex xs12 sm12 md12>
            <v-textarea
              v-model="comment"
              name="input-7-1"
              box
              auto-grow
            ></v-textarea>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="closeCommentModal"
            :disabled="schools.saveLoading"
            color="red"
            flat
          >
            {{ $t('inputs.actions.cancel') }}
          </v-btn>
          <v-btn
            @click="saveComment"
            :loading="schools.saveLoading"
            color="primary"
            flat
          >
            {{ $t('inputs.actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="currentSkiSchool"
      v-model="datePickerModal"
      :return-value.sync="currentSkiSchool.startTime"
      ref="dialog"
      width="290px"
      lazy
      persistent
    >
      <v-date-picker
        v-if="datePickerModal"
        v-model="currentSkiSchool.startDate"
        light
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn
          @click="closeDatePickerModal"
          :disabled="schools.saveLoading"
          color="red"
          flat
        >
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          @click="saveStartDate"
          :loading="schools.saveLoading"
          color="primary"
          flat
        >
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-date-picker>
      <v-alert
        v-if="schools.saveError"
        :value="schools.saveError"
        color="error"
        icon="warning"
      >
        <span v-html="schools.saveError"></span>
      </v-alert>
    </v-dialog>
    <v-dialog
      v-if="currentSkiSchool"
      v-model="timePickerModal"
      :return-value.sync="currentSkiSchool.startTime"
      ref="dialog"
      width="290px"
      lazy
      persistent
    >
      <v-time-picker
        v-if="timePickerModal"
        v-model="currentSkiSchool.startTime"
        format="24hr"
        light
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn
          @click="closeTimePickerModal"
          :disabled="schools.saveLoading"
          color="red"
          flat
        >
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          @click="saveStartTime"
          :loading="schools.saveLoading"
          color="primary"
          flat
        >
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-time-picker>
      <v-alert
        v-if="schools.saveError"
        :value="schools.saveError"
        color="error"
        icon="warning"
      >
        <span v-html="schools.saveError"></span>
      </v-alert>
    </v-dialog>
    <v-dialog
      v-if="selectedSchool"
      v-model="editProductDialog"
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <div v-if="selectedSchool.participants.length" class="headline">
            <template v-if="selectedSchool.maxNumberOfPersons">
              {{ $t('ski.school.products-information-for-multiple-persons', {
                lessonTypeName: selectedSchool.lessonTypeName,
                skiTypeName: selectedSchool.skiTypeName,
                maxNumberOfPersons: selectedSchool.maxNumberOfPersons
              }) }}
            </template>
            <template v-else>
              {{ $t('ski.school.products-information-for', {
                first: selectedSchool.participants[0].firstName,
                last: selectedSchool.participants[0].lastName
              }) }}
              <span class="body-2">
                {{ selectedSchool.personCategoryName }}
              </span>
            </template>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3 mt-0">
          <v-container class="pt-0 mt-0" grid-list-md>
            <v-alert
              v-if="schools.saveError"
              :value="schools.saveError"
              color="error"
              icon="warning"
              outline
            >
              <span v-html="schools.saveError"></span>
            </v-alert>
            <v-layout wrap>
              <v-flex class="pt-0 mt-0" xs12 sm12 md12>
                <h2>
                  {{ $t('ski.school.override-prices') }}
                  <v-chip v-if="isPriceChanged" color="red" text-color="white" disabled>
                    {{ $t('ski.school.price-modified-and-not-saved-yet') }}
                  </v-chip>
                </h2>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedSchool.price"
                  @input="onPriceOverrideChange"
                  :suffix="booking.currency"
                  :disabled="
                    loading
                    || bookingParticipants.itemsLoading
                    || availableSchoolProducts.itemsLoading
                  "
                  :label="$t('ski.school.price-gross')"
                  required
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedSchool.priceNet"
                  @input="onPriceOverrideChange"
                  :suffix="selectedSchool.currencyNet"
                  :disabled="
                    loading
                    || bookingParticipants.itemsLoading
                    || availableSchoolProducts.itemsLoading
                    || selectedSchool.cancellationFeeNet !== null
                  "
                  :label="$t('ski.school.price-net')"
                  required
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="selectedSchool.cancellationFeeNet"
                  :suffix="selectedSchool.currencyNet"
                  :disabled="loading || selectedSchool.cancellationFeeNet === null"
                  :label="$t('ski.school.cancellation-fee-net')"
                  placeholder="0"
                  @input="onPriceOverrideChange"
                />
              </v-flex>

            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <h2>
                  {{ $t('ski.school.change-product') }}
                  <v-chip v-if="isProductChanged" color="red" text-color="white" disabled>
                    {{ $t('ski.school.product-modified-and-not-saved-yet') }}
                  </v-chip>
                </h2>
              </v-flex>
              <v-flex class="text-xs-right" xs12 sm6>
                <v-select
                  @change="setChangeProductBookingParticipant"
                  :value="selectedBookingParticipantId"
                  :items="participants"
                  :loading="participants.itemsLoading"
                  :disabled="participants.itemsLoading || !participants.length"
                  :label="$t('ski.school.selects.booking-participant')"
                  item-text="fullName"
                  item-value="id"
                />
              </v-flex>
              <v-flex v-if="areas.length > 1" sm2 xs12>
                <v-select
                  @change="setChangeProductArea"
                  :value="selectedAreaIdForChangeProduct"
                  :items="areas"
                  :loading="
                    bookingParticipants.itemsLoading
                    || availableSchoolProducts.itemsLoading
                  "
                  :disabled="
                    bookingParticipants.itemsLoading
                    || availableSchoolProducts.itemsLoading
                  "
                  :label="$t('ski.school.selects.area')"
                  item-text="name"
                  item-value="id"
                />
              </v-flex>
              <v-flex xs12 sm4>
                <v-btn
                  @click="searchAvailableProducts"
                  :loading="availableSchoolProducts.itemsLoading"
                  color="warning"
                  dark
                >
                  {{ $t('ski.school.search-product') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <template
              v-if="isSearchingForAnotherProduct && Object.keys(availableSchoolProducts).length"
            >
              <v-layout wrap>
                <v-flex xs12 sm3>
                  <v-select
                    @change="setChangeProductLessonType"
                    :value="selectedLessonTypeId"
                    :items="availableLessonTypes"
                    :loading="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                     "
                    :disabled="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                    "
                    :label="$t('ski.school.selects.lesson-type')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    @change="setChangeProductNumberOfDays"
                    :value="selectedNumberOfDays"
                    :items="availableNumberOfDaysUsedForChangeProduct"
                    :loading="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                     "
                    :disabled="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                    "
                    :label="$t('ski.school.selects.number-of-days')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    @change="setChangeProductNumberOfPersons"
                    :value="selectedNumberOfPersons"
                    :items="availableNumberOfPersons"
                    :loading="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                     "
                    :disabled="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                    "
                    :label="$t('ski.school.selects.number-of-persons')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
                <v-flex v-if="selectedNumberOfPersons === 1" xs12 sm3>
                  <v-select
                    @change="setChangeProductPersonCategory"
                    :items="availablePersonCategoriesUsedForChangeProduct"
                    :disabled="loading || availableSchoolProducts.itemsLoading"
                    :value="selectedPersonCategoryId"
                    :label="$t('ski.school.selects.person-category')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex v-if="selectedLessonTypeId === lessonTypeEnums.GROUP" xs12 sm3>
                  <v-select
                    @change="setChangeProductWeekDayNumber"
                    :value="selectedWeekDayNumber"
                    :items="availableWeekDays"
                    :loading="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                     "
                    :disabled="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                    "
                    :label="$t('ski.school.selects.week-day')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    @change="setChangeProductLessonDuration"
                    :value="selectedLessonDuration"
                    :items="availableLessonDurations"
                    :loading="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                     "
                    :disabled="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                    "
                    :label="$t('ski.school.selects.lesson-duration')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    @change="setChangeProductSkiType"
                    :value="selectedSkiTypeId"
                    :items="availableSkiTypes"
                    :loading="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                     "
                    :disabled="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                    "
                    :label="$t('ski.school.selects.ski-type')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    @change="setChangeProductLevelType"
                    :value="selectedLevelId"
                    :items="availableLevelTypes"
                    :loading="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                     "
                    :disabled="
                      bookingParticipants.itemsLoading
                      || availableSchoolProducts.itemsLoading
                    "
                    :label="$t('ski.school.selects.level-type')"
                    item-text="name"
                    item-value="id"
                    required
                  />
                </v-flex>
              </v-layout>
            </template>
            <v-layout wrap>
              <template v-if="isSearchingForAnotherProduct">
                <template v-if="availableSkiSchoolProductUsedForChangeProduct">
                  <v-flex xs12 sm12>
                    <h3>{{ $t('ski.school.available-product-and-price-found') }}</h3>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <p class="font-weight-bold pb-0 mb-0">
                      {{ $t('ski.school.total') }}:
                    </p>
                  </v-flex>
                  <v-flex xs12 sm9>
                    <p class="font-weight-bold pb-0 mb-0">
                      {{ availableSkiSchoolProductUsedForChangeProduct.priceGross }}
                      {{ booking.currency }}
                      <span class="blue-grey--text body-2 caption">
                        / {{ availableSkiSchoolProductUsedForChangeProduct.priceNet }}
                        {{
                          availableSkiSchoolProductUsedForChangeProduct.season.supplier.currency
                        }}
                      </span>
                    </p>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-btn
                      @click="takeGrossNetPrice(availableSkiSchoolProductUsedForChangeProduct)"
                      :loading="availableSchoolProducts.itemsLoading"
                      color="warning"
                      dark
                    >
                      {{ $t('ski.school.take-gross-net-price') }}
                    </v-btn>
                  </v-flex>
                </template>
                <template v-else>
                  <h3 v-if="!availableSchoolProducts.itemsLoading" class="red--text">
                    {{ $t('ski.school.no-available-price-found') }}
                  </h3>
                </template>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="closeProductDialog"
            :loading="loading"
            color="red darken-1"
            flat
          >
            {{ $t('dialog.actions.close') }}
          </v-btn>
          <v-btn
            @click="openConfirmDialog('confirm-save-product-dialog')"
            :disabled="!canChangeProduct"
            :loading="loading || availableSchoolProducts.saveLoading"
            color="green darken-1"
            flat
          >
            {{ $t('dialog.actions.save') }}
          </v-btn>
          <confirm-dialog
            @confirm="saveProductDialog"
            :title="$t('ski.school.confirm-title')"
            :description="$t('ski.school.saveAreYouSure')"
            ref="confirm-save-product-dialog"
          >
          </confirm-dialog>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/school/SkiSchoolOverview.vue